import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import {
    PastConsultationData,
    ReportsPrescriptionData,
    patient_consultation,
    consultation_table_model
} from 'src/app/models/patient-profile';
import { ApiResult } from 'src/app/models/PromiseResult';
import { DoctorsService } from 'src/app/services/doctors.service';
import { PatientviewService } from 'src/app/services/patientview/patientview.service';

@Component({
    selector: 'app-eglobaldoctors-conultations',
    templateUrl: './eglobaldoctors-conultations.component.html',
    styleUrls: [
        './eglobaldoctors-conultations.component.css',
        '../../../../../assets/css/print-prescription.css',
        '../../../../../assets/css/custom-egd.css'
    ]
})
@TraceClassDecorator()
export class EglobaldoctorsConultationsComponent implements OnInit {
    @Input('patient_guid')
    patient_guid: string = '';

    past_consultation_data: PastConsultationData =
        this.init_pastConsultationData();

    init_ReportsPrescriptionData(): ReportsPrescriptionData {
        let a: ReportsPrescriptionData;
        a = {
            display: null,
            show: 'show',
            printcontent: 'print-content',
            posting: false,
            data: {
                input: {
                    patient_guid: '',
                    consultation_id: null
                },
                apiData: new ApiResult(true),
                data: null
            }
        };
        return a;
    }

    init_pastConsultationData(): PastConsultationData {
        let a: PastConsultationData;

        a = {
            past_consultation: {
                data: {
                    input: {
                        patient_guid: '',
                        consultation_id: null
                    },
                    apiData: new ApiResult(true),
                    consultation_data: []
                }
            },
            reports: this.init_ReportsPrescriptionData(),
            prescription: this.init_ReportsPrescriptionData()
        };

        return a;
    }

    constructor(
        private readonly doctorsService: DoctorsService,
        private readonly patientviewService: PatientviewService
    ) {}

    async ngOnInit(): Promise<void> {}

    async init() {
        await this.getPastConsultations();
    }

    async getPastConsultations(): Promise<void> {
        this.past_consultation_data.past_consultation.data.apiData.Posting =
            true;
        await this.patientviewService
            .fetchPastConsultations(this.patient_guid)
            .toPromise()
            .then((result) => {
                if (result.success) {
                    this.past_consultation_data.past_consultation.data.apiData.PromiseResult =
                        result;

                    const consultation: patient_consultation[] =
                        result.data.data;
                    const temp: consultation_table_model[] = [];

                    consultation.map((ele) => {
                        let ele_new: consultation_table_model;
                        ele_new = {
                            sr_no: temp.length,
                            consultation_date: ele.consultation_date,
                            specialty_name: ele.p_consultation_appointment.map(
                                (appt) => {
                                    return appt.d_specialty_type.specialty_name;
                                }
                            ),
                            priority_type: ele.priority_type.priority_type,
                            doctor_name: ele.p_consultation_appointment.map(
                                (appt) => {
                                    return !ele.consultation_date
                                        ? 'N/A'
                                        : appt.egd_users.first_name +
                                              ' ' +
                                              appt.egd_users.last_name;
                                }
                            ),
                            doctor_report: '',
                            prescriptions: ele.p_prescriptions,
                            consultation_id: ele.id,
                            consultation_status: ele.consultation_status
                        };
                        temp.push(ele_new);
                    });

                    this.past_consultation_data.past_consultation.data.consultation_data =
                        temp;
                }
            })
            .catch((error: HttpErrorResponse) => {
                this.past_consultation_data.past_consultation.data.consultation_data =
                    [];
                this.past_consultation_data.past_consultation.data.apiData.ServerError =
                    error.error;
                this.past_consultation_data.past_consultation.data.apiData.Posting =
                    false;
                this.past_consultation_data.past_consultation.data.apiData.PromiseResult.success =
                    false;
            });
        this.past_consultation_data.past_consultation.data.apiData.Posting =
            false;
    }

    async Report(consultation_id: number) {
        this.past_consultation_data.reports =
            this.init_ReportsPrescriptionData();
        this.past_consultation_data.reports.show = 'showDoctorReports';
        this.past_consultation_data.reports.data.input.patient_guid =
            this.patient_guid;
        // this.patient_guid = this.patient_guid;
        this.past_consultation_data.reports.data.input.consultation_id =
            consultation_id;
        await this.GetDoctorReportsData();
        this.past_consultation_data.reports.display = true;
    }

    async Prescription(consultation_id: number) {
        this.past_consultation_data.prescription =
            this.init_ReportsPrescriptionData();
        this.past_consultation_data.prescription.show = 'showPrescription';

        this.past_consultation_data.prescription.data.input.patient_guid =
            this.patient_guid;
        // this.patient_guid = this.patient_guid;
        this.past_consultation_data.prescription.data.input.consultation_id =
            consultation_id;
        await this.GetPrescriptionData();
        this.past_consultation_data.prescription.display = true;
    }

    private async GetPrescriptionData() {
        this.past_consultation_data.prescription.posting = true;
        await this.doctorsService
            .GetDoctorReportspdf(
                this.past_consultation_data.prescription.data.input
                    .patient_guid,
                this.past_consultation_data.prescription.data.input
                    .consultation_id,
                'prescription'
            )
            .toPromise()
            .then((result) => {
                this.past_consultation_data.prescription.data.apiData.PromiseResult =
                    result;
                if (result.success) {
                    this.past_consultation_data.prescription.data.data =
                        result.data;
                }
                this.past_consultation_data.prescription.posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.past_consultation_data.prescription.data.apiData.ServerError =
                    error.error;
                this.past_consultation_data.prescription.data.apiData.PromiseResult.success =
                    false;
                this.past_consultation_data.prescription.posting = false;
            });
    }

    private async GetDoctorReportsData() {
        this.past_consultation_data.reports.posting = true;

        await this.doctorsService
            .GetDoctorReportspdf(
                this.past_consultation_data.reports.data.input.patient_guid,
                this.past_consultation_data.reports.data.input.consultation_id,
                'report'
            )
            .toPromise()
            .then((result) => {
                this.past_consultation_data.reports.data.apiData.PromiseResult =
                    result;
                if (result.success) {
                    this.past_consultation_data.reports.data.data = result.data;
                }
                this.past_consultation_data.reports.posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.past_consultation_data.reports.data.apiData.ServerError =
                    error.error;
                this.past_consultation_data.reports.data.apiData.PromiseResult.success =
                    false;
                this.past_consultation_data.reports.posting = false;
            });
    }

    print() {
        window.print();
    }
}
